<template>
  <div>
    <v-data-table
    dense
    v-resize="onResize"
    id="time__table"
    :items-per-page="-1" 
    fixed-header
    :footer-props="{ itemsPerPageOptions: [-1] }"
    :headers="headers"
    :items="items"
    no-data-text="측정된 자료가 없습니다."
    class="table_content"
    single-select
    hide-default-footer
    >
      <template v-slot:item="{ item }">
        <tr v-if="!isMobile">
          <td class="table_line info_num">{{ entityNo(item.entity_no) }}</td>
          <td class="table_line cow" @click="$emit('detailInfo', item.entity_no)">
            <v-icon size="24" color="black">
              mdi-cow
            </v-icon>
          </td>
          <td class="table_line"> {{ item.breed }}</td>
          <td class="table_line"> {{ item.grade.qgrade === 'D' ?'등외': item.grade.qgrade }}</td>
          <td class="table_line"> {{ item.grade.wgrade === '' ? '-' : item.grade.wgrade }}</td>

          <td class="table_line"> {{ item.abatt_weight }}</td>
          <td class="table_line"> {{ item.sex }}</td>
          <td class="table_line"> {{ item.birth_month }}</td>

        </tr>

        <tr v-else  class="mobile_tr">
          <td class="mb_table">
            <div class="date mt-2">
              <div class="flex-title"> 이력번호 </div>
              <div  @click="$emit('detailInfo',  410+item.entity_no)">
                <v-icon size="24" color="white">
                  mdi-cow
                </v-icon> 
                {{ item.entity_no }}
              </div>
            </div>

            <div class="flex mb-2">
              <div class="flex-content">
                <div class="weight">품종</div>
                <div> {{ item.breed }} </div>
              </div>
            </div>

            <div class="flex mb-2">
              <div class="flex-content">
                <div class="weight">육질등급</div>
                <div> {{ item.grade.qgrade === 'D' ?'등외': item.grade.qgrade }} </div>
              </div>
            </div>

            <div class="flex mb-2">
              <div class="flex-content">
                <div class="weight">육량등급</div>
                <div> {{ item.grade.wgrade === '' ? '-' : item.grade.wgrade }} </div>
              </div>
            </div>

            <div class="flex mb-2">
              <div class="flex-content">
                <div class="weight">도체중</div>
                <div> {{ item.abatt_weight }} </div>
              </div>
            </div>

            <div class="flex mb-2">
              <div class="flex-content">
                <div class="weight">성별</div>
                <div> {{ item.sex }} </div>
              </div>
            </div>

            <div class="flex mb-2">
              <div class="flex-content">
                <div class="weight">출하월령</div>
                <div> {{ item.birth_month }} </div>
              </div>
            </div>

            <div class="line-table"></div>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "CustomTable",
  props: {
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    sortBy: {
      type: String,
      default: "date",
    },
    sortDesc: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isMobile: false,
    };
  },
  methods: {
    toggleSort(column) {
      if (this.sortBy === column) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortBy = column;
        this.sortDesc = false;
      }
    },
    addCommas(num) {
      if (typeof num === "number") {
        return num.toLocaleString();
      }
      return num;
    },
    onResize() {
      this.isMobile = window.innerWidth < 769;
    },
    entityNo(entity){
      if (!entity) return "";
      return entity.replace(/^(\d{3})(\d{5})(\d{3})(\d)$/, "$1 $2 $3 $4");
    },

  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style scoped lang="scss">
@import '../../../style/table_mb.scss';
.table_line{
  border-right:1px solid #cfcfcf !important;
  text-align: center;
}
.detail{
  cursor: pointer;
}
::v-deep .v-data-table th {
  background-color: #73a9ff !important;
  text-align: center !important;
  vertical-align: middle !important;
}
.v-table td {
  text-align: center;
  vertical-align: middle;
}
.cow{
  cursor: pointer;
}
</style>
